import WorkerApiService from "../../workerApiServices";

class ProvisaoService extends WorkerApiService {

    constructor() {
        super('/api/provisao')
    }

    save(object){
        return this.post("/save", object)
    }

    createRecorrencia(object){
        return this.post("/createRecorrencia", object)
    }

    jaExisteTipoDePagamentoAndNumeroDocumento(object){
        return this.post("/jaExisteTipoDePagamentoAndNumeroDocumento", object)
    }

    edit(object){
        return this.put("/edit", object)
    }

    deleteById(id){
        return this.delete(`/delete/${id}`)
    }

    deleteRecorrenciasByProvisaoBase(id){
        return this.delete(`/deleteRecorrenciasByProvisaoBase/${id}`)
    }

    searchById(id){
        let params = `?`
        params = `${params}&id=${id}`
        return this.get(`/searchById${params}`)
    }

    buscaProvisoesRecorrentesFuturas(id){
        let params = `?`
        params = `${params}&id=${id}`
        return this.get(`/buscaProvisoesRecorrentesFuturas${params}`)
    }

    searchByNFId(nfId){
        let params = `?`
        params = `${params}&nfId=${nfId}`
        return this.get(`/searchByNFId${params}`)
    }

    searchByNFSeId(nfseId){
        let params = `?`
        params = `${params}&nfseId=${nfseId}`
        return this.get(`/searchByNFSeId${params}`)
    }

    searchLancamentos(object){
        return this.post("/searchLancamentos", object)
    }
    
    searchProvisaoProdutos(initialDate, finalDate, tipoProdutoList){
        
        const data = {
            initialDate,
            finalDate,
            tipoProdutoList
        }
            
        // console.log("searchProvisaoProdutos: ", data)
        
        return this.post(`/produtos`, data)
    }
    
    detalhaCMVDreCompetencia(initialDate, finalDate, tipoProdutoList){
        
        const data = {
            initialDate,
            finalDate,
            tipoProdutoList
        }
            
        // console.log("searchProvisaoProdutos: ", data)
        
        return this.post(`/detalhaCMVDreCompetencia`, data)
    }

    informarPagamento(object){
        return this.post("/informarPagamento", object)
    }

    desfazerPagamento(object){
        return this.post(`/desfazerPagamento`, object)
    }

    searchDadosPagamento(parcelaProvisaoId){
        let params = `?`
        params = `${params}&parcelaProvisaoId=${parcelaProvisaoId}`
        return this.get(`/searchDadosPagamento${params}`)
    }

    buscaAcrescimoDescontoParcelaProvisao(parcelaProvisaoId, tipo){
        let params = `?`
        params = `${params}&parcelaProvisaoId=${parcelaProvisaoId}`
        params = `${params}&tipo=${tipo}`
        return this.get(`/buscaAcrescimoDescontoParcelaProvisao${params}`)
    }
    
    saveAcrescimoDesconto(object){
        return this.post(`/saveAcrescimoDesconto`, object)
    }
    
    deleteAcrescimoDesconto(idAcrescimoOuDesconto){
        return this.delete(`/deleteAcrescimoDesconto/${idAcrescimoOuDesconto}`)
    }
    
    atualizaGrupoDePagamentoFromProvisao(provisao, grupoDePagamento){
        let body = {
            provisao,
            grupoDePagamento
        }
        return this.put(`/atualizaGrupoDePagamento`, body)
    }

}

export default ProvisaoService